import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { v4 as uuid } from "uuid";
import {
  addItem,
  addItemToWish,
  clearState,
  deletePlain,
  getDetailId,
} from "../actions/index";
import Calendario from "./Calendario";
import Carousel from "./Carousel";
import CarouselCom from "./CarouselCom";
import UserReviews from "./UserReviews";

function Details() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const detail = useSelector((state) => state.detail);
  const [item, setItem] = useState({}); //Estado para construir item y agregarlo al carrito
  const [, setDisabled] = useState(true);
  const user = localStorage.getItem("user");
  const cart = useSelector((state) => state.cartPlains);
  const admin = useSelector((state) => state.isAdmin);

  const history = useHistory();

  const cartId = uuid();

  useEffect(() => {
    dispatch(getDetailId(id));
    dispatch(clearState());
  }, [dispatch, id]);

  const handleDate = (date) => {
    if (date) {
      let dateJson = JSON.stringify(date);
      let dateJsonSliced = dateJson.slice(1, 11);
      setItem((prevState) => {
        return { ...prevState, date: dateJsonSliced };
      });
    }
  };

  console.log(item);

  const handleAddCart = () => {
    if (!item.date && !item.quantity) {
      return swal(
        "Error",
        "Debe seleccionar una fecha y una cantidad",
        "error"
      );
    } else if (!item.date) {
      return swal({
        title: "¡Seleccione una fecha!",
        icon: "error",
      });
    } else if (!item.quantity) {
      return swal({
        title: "¡Seleccione cantidad de personas!",
        icon: "error",
      });
    } else {
      dispatch(
        addItem({
          ...item,
          name: detail.title,
          price: detail.price,
          image: detail.images,
          city: detail.city,
          location: detail.location,
          cartId: cartId,
          stock: detail.stock,
          id,
        })
      );
      history.push("/destination");
    }
  };

  const handleAddWish = () => {
    dispatch(addItemToWish(id));
    // dispatch(
    //   addItemToWish({
    //     ...item,
    //     name: detail.title,
    //     price: detail.price,
    //     image: detail.images,
    //     city: detail.city,
    //     location: detail.location,
    //     cartId: cartId,
    //     stock: detail.stock,
    //     id,
    //   })
    // );
    history.push("/destination");
  };

  const handleQuantity = (e) => {
    setItem((prevState) => {
      if (e.target.value > detail.stock || e.target.value <= 0) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
      return { ...prevState, [e.target.name]: parseInt(e.target.value) };
    });
  };

  const handleDelete = (id) => {
    swal({
      title: "¿Está seguro de eliminar este paquete?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("¡Eliminado!", "El paquete ha sido eliminado", "success");
        dispatch(deletePlain(id));
        history.push("/destination");
      }
    });
  };

  console.log("score", detail?.score);
  console.log("comments", detail?.comments?.length);

  // create a function that checks if the item in the cart has the same id and date as the detail
  const checkIdDate = (cart) => {
    return cart.find(
      (cartItem) => cartItem.date === item.date && cartItem.id === id
    );
  };

  const renderStock = () => {
    const checkedIdDate = checkIdDate(cart);
    if (checkedIdDate) {
      return (
        <h3 className="text-base leading-4 text-gray-800 m-2">
          Máximo: {detail.stock - checkedIdDate.quantity} personas
        </h3>
      );
    } else {
      return (
        <h3 className="text-base leading-4 text-gray-800 m-2">
          Máximo: {detail.stock} personas
        </h3>
      );
    }
  };

  const maxStockInput = () => {
    const checkedIdDate = checkIdDate(cart);
    if (checkedIdDate) {
      return (
        <input
          className="border-solid border-2 border-indigo-300"
          type="number"
          name="quantity"
          min={1}
          max={detail.stock - checkedIdDate.quantity}
          onChange={handleQuantity}
          value={item.quantity}
          disabled={detail.stock - checkedIdDate.quantity === 0 ? true : false}
        />
      );
    } else {
      return (
        <input
          className="border-solid border-2 border-indigo-300"
          type="number"
          name="quantity"
          min={1}
          max={detail.stock}
          onChange={handleQuantity}
          value={item.quantity}
        />
      );
    }
  };

  return (
    <div className="bg-slate-200">
      <div className="border-2 border-indig-300 mx-28  bg-gray-100/90">
        <div className="h-5 relative">
          {admin ? (
            <div className="flex justify-between">
              <button className="absolute top-0.5 left-3 bg-indigo-300 hover:bg-blue-300 text-white font-bold py-1 px-3 rounded-full">
                <Link to={`/editarservicios/${id}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                  </svg>
                </Link>
              </button>
              <button
                onClick={() => handleDelete(id)}
                className="absolute top-0.5 right-3 bg-red-500 hover:bg-red-400 text-white font-bold py-1 px-3 rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          ) : null}
        </div>
        <div>
          <div className="bg-indigo-300">
            <h3 className="ml-11 mt-4 p-2 font-bold text-3xl text-white text-center">
              {detail.title}
            </h3>
          </div>

          <div className="flex justify-between">
            <div className="ml-5 mt-5">
              {detail.city}, {detail.location}
            </div>
            {detail?.score?.toFixed(1) <= 2 ? (
              <h3 className="text-right mr-10">
                {" "}
                Puntaje:{" "}
                <p className="text-red-500">{detail?.score?.toFixed(1)}</p>
              </h3>
            ) : (
              <h3 className="text-right mr-10">
                Puntaje:
                <p className="text-green-500">{detail?.score?.toFixed(1)}</p>
              </h3>
            )}
          </div>
          <Carousel />
        </div>

        <br />

        <div className=" mx-12">
          <p>{detail.description}</p>
        </div>

        <br />

        <div>
          <p className="bg-indigo-300 text-white">
            <strong>INCLUYE: </strong>
          </p>
          <div>
            <h4 className="ml-12">-{detail?.included}</h4>
          </div>
        </div>
        <hr className="bg-indigo-300 h-5" />
        <div className="flex justify-evenly mt-5">
          <div className="flex items-center">
            <h3 className="text-base leading-4 text-gray-800 m-2">Fecha:</h3>
            <Calendario handleDate={handleDate} detailsDates={detail.date} />
          </div>
          <div className="py-2 pr-2 flex items-center">
            <h3 className="text-base leading-4 text-gray-800 m-2">
              Personas:{" "}
            </h3>
            {/* <input onChange={(e) => handleQuantity(e)} className="border-solid border-2 border-indigo-300" type="number" name="quantity" min={1} max={}/> */}
            {maxStockInput()}
          </div>
          <div>
            {/* <h3 className="text-base leading-4 text-gray-800 m-2">
							Máximo:{" "}
							{detail.stock} personas
						</h3> */}
            {renderStock()}
            <h3 className="text-base leading-4 text-gray-800 m-2">
              Precio: ${detail.price}
            </h3>
          </div>
        </div>

        <br />
        <div className="mx-52 border-2 border-indigo-500 mb-5 rounded-md bg-indigo-300 text-white list-none">
          <p className="mt-3 ml-5">
            <strong>COMENTARIOS: </strong>
          </p>
          <CarouselCom />
        </div>
        <UserReviews />
        <div className="flex justify-center gap-56 mb-4 text-1xl font-mono text-teal-500">
          <Link to="/destination">
            <button className="rounded-2xl py-2 p-3 focus:outline-none focus:ring focus:ring-indigo-500 bg-indigo-400 hover:bg-indigo-300 relative text-white font-semibold">
              VOLVER
            </button>
          </Link>
          {user ? (
            <div className="">
              <button
                className="bg-indigo-400 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-5"
                onClick={handleAddWish}
                // disabled={disabled}
              >
                Agregar a la wishlist
              </button>
              <button
                className="bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={handleAddCart}
              >
                Agregar al carrito
              </button>
            </div>
          ) : (
            <Link to="/login">
              <button className="bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Agregar al carrito
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
export default Details;
